// Tracks whether a product is currently being dragged from the catalog into
// the scene. Used to suppress UI that shouldn't compete with the drag — e.g.
// the mobile selection sheet, which otherwise pops up over the canvas the user
// is dragging onto.
//
// The drag is owned by configurator-viewer.js (it listens for pointerdown on
// any [data-product-id] element). We can't see its internal state, so we mirror
// it from the same DOM signals: a pointerdown/touchstart that lands on a drag
// source starts the drag; the next pointerup/touchend/cancel ends it. Listeners
// are on document (capture) so we see the start before the drag JS calls
// preventDefault/stopPropagation.

import { useEffect, useState } from "react";

export function useIsDraggingProduct(): boolean {
  const [dragging, setDragging] = useState(false);

  useEffect(() => {
    const onDown = (e: Event) => {
      const target = e.target as HTMLElement | null;
      // A drag source is anything carrying [data-product-id] (desktop whole-row
      // or the mobile drag handle). closest() walks up from the actual hit node.
      if (target?.closest?.("[data-product-id]")) setDragging(true);
    };
    const onUp = () => setDragging(false);

    document.addEventListener("pointerdown", onDown, true);
    document.addEventListener("touchstart", onDown, true);
    document.addEventListener("pointerup", onUp, true);
    document.addEventListener("touchend", onUp, true);
    document.addEventListener("touchcancel", onUp, true);
    return () => {
      document.removeEventListener("pointerdown", onDown, true);
      document.removeEventListener("touchstart", onDown, true);
      document.removeEventListener("pointerup", onUp, true);
      document.removeEventListener("touchend", onUp, true);
      document.removeEventListener("touchcancel", onUp, true);
    };
  }, []);

  return dragging;
}
